import { getParams } from './utils';
var DebugEnvFactory = /* @__PURE__ */ (function () {
    function DebugEnvFactory() {
        var _a;
        this.isClose = function () { return localStorage.getItem('im-close') === '1'; };
        this.isAi = function () { return localStorage.getItem('im-ai') === '1'; };
        this.isAuth = function () { return localStorage.getItem('chat-auth') === '1'; };
        this.showDebug = getParams((_a = window.location) === null || _a === void 0 ? void 0 : _a.search.substring(1), 'showDebug') === '1';
    }
    return DebugEnvFactory;
}());
export var DebugEnv = new DebugEnvFactory();
